<svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1996_1144)">
<mask id="path-2-inside-1_1996_1144" fill="white">
<rect x="13.1874" y="9.14941" width="12" height="7" rx="1"/>
</mask>
<rect x="13.1874" y="9.14941" width="12" height="7" rx="1" stroke="currentColor" stroke-width="3.4" mask="url(#path-2-inside-1_1996_1144)"/>
<rect x="13.1874" y="18.3494" width="12" height="6.5" rx="1" fill="currentColor"/>
<path d="M9.81274 24.2725L9.81274 19.3418" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_1996_1144">
<rect width="22" height="22" fill="white" transform="translate(6.5 6)"/>
</clipPath>
</defs>
</svg>
